<template>
  <div class="createbid">
    <Common></Common>
    <div class="content">
      <div class="sw-box" v-if="IfSetInfo">
        <div class="sw">
          <span>{{$t('label.w143')}}:</span>
          <span class="sp">{{Invalid==false?$t('option.w52'):$t('option.w53')}}</span>
          <i-switch :value="!Invalid" @on-change="swchange"></i-switch>
        </div>
      </div>
      <div class="main" :class="{disabled:Invalid}">
        <div class="allmoney">
          <p class="p1">
            <span class="s1">{{$t('label.w144')}}</span>
          </p>
          <Input type="text" :placeholder="$t('pl.p21')" v-model="reservedAmount" @on-blur="handleBlur('reservedAmount')"/>
          <p class="up">{{reservedAmount | upmoney}}</p>
          <span class="fixed">{{$t('label.w5')}}</span>
        </div>
        <div class="rate">
          <span class="s1">{{$t('label.w3')}}</span>
          <Input type="text" :placeholder="$t('pl.p32').replace('{%}',maxRate)" v-model="minRate" @on-blur="handleBlur('minRate')"/>
          <span class="fixed">%</span>
        </div>
        <div>
          <span class="s1">{{$t('label.w4')}}</span><span :style="{float:'right'}"><Checkbox v-model="days_allcheck" @on-change="checkalldays" class="textstyle">{{days_allcheck?$t('option.w67'):$t('option.w1')}}</Checkbox></span>
          <CheckboxGroup v-model="cycleDay" @on-change="sortarr">
            <Checkbox class="tabstyle" :label="v.v" v-for="v in loandays" :key="v.v">{{v.n}}{{v.t=='d'?$t('label.w15'):$t('label.w14')}}</Checkbox>
          </CheckboxGroup>
        </div>
        <p class="p2">
          <span class="color-b s2">{{$t('label.w146')}}</span>
        </p>
        <DntypeFilter ref="DntypeFilter" :check-all-btn-top="-43" @change="pledgeRulesChange" :init-value="initPledgeRules"/>
        <div :style="{marginTop:'20px'}">
          <Checkbox v-model="agree">
            <span>{{$t('other.w63')}}</span> <a href="javascript:;" class="color-blue" @click="protocolShow([2,3])">{{$t('other.w59')}}</a><span>/</span><a href="javascript:;" class="color-blue" @click="protocolShow([3,2])">{{$t('other.w60')}}</a>
          </Checkbox>
        </div>
        <div class="btn"><Button :disabled="btnDisabled" :loading="btnLoading" @click="submit">{{IfSetInfo?$t('btn.b63'):$t('btn.b64')}}</Button></div>
      </div>
    </div>
    <Protocol ref="Protocol" @yes="proyes" @no="prono"/>
  </div>
</template>

<script>
import Protocol from "@/components/protocolModal"
import DntypeFilter from "@/components/dntypeFilter"
import {post} from '@/libs/axios'
import Common from "./common.vue"
import {loandays} from '@/libs/sysconst'
export default {
  components: { Common ,Protocol,DntypeFilter},
  data(){
    return {
      Invalid:true,
      IfSetInfo:undefined,
      maxRate:25,
      agree:false,
      reservedAmount:'',
      minRate:'',
      cycleDay:[],
      pledgeRules:'',
      btnLoading:false,
      initPledgeRules:null,
      loandays,
      days_allcheck:false
    }
  },
  mounted(){
    this.getdata()
  },
  computed:{
    btnDisabled(){
      return (
        !this.agree||
        !this.reservedAmount||
        isNaN(this.reservedAmount)||
        !this.minRate||
        isNaN(this.minRate)||
        this.minRate>this.maxRate||
        !this.cycleDay.length
      )
    }
  },
  watch:{
    cycleDay(v){
      this.days_allcheck=v.length==this.loandays.length
    }
  },
  methods:{
    async getdata(){
      let res=await this.$axios.get('/Member/RZJLoan/KeepInvestInfo')
      if(res.err) return;
      if(!res.IfSetInfo) return this.protocolShow([2,3]);
      this.IfSetInfo=res.IfSetInfo
      if(!res.KeepInvestInfo.length) return;
      res.KeepInvestInfo=res.KeepInvestInfo[0]
      this.Invalid=res.KeepInvestInfo.Invalid
      this.reservedAmount=res.KeepInvestInfo.ReservedAmount.toString()
      this.minRate=res.KeepInvestInfo.MinRate
      this.cycleDay=res.KeepInvestInfo.CycleRule.map(v=>Number(v))
      this.initPledgeRules=res.KeepInvestInfo.DomainTypeList
    },
    sortarr(){
      this.cycleDay = this.cycleDay.sort( (a,b) =>{
        return a-b
      })
    },
    handleBlur(t){
      switch(t){
        case 'reservedAmount':
          {
            let v=this.reservedAmount.toString()
            .replace(/\..*/,'')
            .replace(/[^\d]/g,'')
            .replace(/^0+/,'')
            if(v=='') return;
            v=Number(v)
            this.reservedAmount=v.toString()
          }
          break;
        case 'minRate':
          {
            let v=this.minRate.toString()
            .replace(/\.(\d).*/,'.$1')
            .replace(/[^\d\.]/g,'')
            .replace(/^0+/,'')
            if(v=='') return;
            v=Number(v)
            if(v>this.maxRate) v=this.maxRate
            this.minRate=v.toString()
          }
          break;
      }
    },
    async submit(){
      this.btnLoading=true
      let res=await post('/Member/RZJLoan/CreateKeepInvest',{
        reservedAmount:this.reservedAmount,
        minRate:this.minRate,
        cycleDay:this.cycleDay.join(','),
        pledgeRules:this.pledgeRules
      })
      this.btnLoading=false
      this.IfSetInfo=true
      res.throw()
    },
    protocolShow(arr){
      this.$refs.Protocol.type=arr
      this.$refs.Protocol.modal=true
    },
    proyes(){
      if(this.Invalid==false){
        this.agree=true
      }else{
        this.Invalid=false
        if(this.IfSetInfo) this.swchange()
      }
    },
    prono(){
      if(this.Invalid==false){
        this.agree=false
      }else{
        this.$router.push({name:'autobid'})
      }
    },
    agreechange(){
      if(!this.agree) return;
      this.protocolShow([2,3])
    },
    async swchange(){
      this.Invalid=!this.Invalid
      let res=await this.$axios.post('/Member/RZJLoan/SetKeepInvestInvalid',{
        invalid:this.Invalid
      })
      if(res.err) this.Invalid=!this.Invalid
    },
    pledgeRulesChange(v){
      this.pledgeRules=v
    },
    checkalldays(v){
      if(v){
        this.cycleDay=this.loandays.map(vv=>vv.v)
      }else{
        this.cycleDay=[]
      }
    }
  }
};
</script>

<style lang="less" scoped>
.createbid {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .color-b {
      color: #232325;
    }
    .color-blue {
      color: #5e8ffc;
    }
    // .opacity{
    //   opacity: 0.6;
    // }
    .sw-box {
      width: 460px;
      height: 30px;
      .sw {
        font-weight: 500;
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: center;
        .sp {
          padding: 0 20px 0 10px;
        }
      }
    }
    .main {
      width: 460px;
      position: relative;
      &.disabled{
        &:before{
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          content: '';
          background: rgba(255,255,255,.6);
          width: 100%;
          height: 100%;
          z-index: 10;
        }
      }
      .s1 {
        margin-bottom: 3px;
        color: #7b7b7c;
        display: inline-block;
      }
      .fixed {
        font-size: 14px;
        color: #333;
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
      .allmoney {
        margin: 20px 0 27px 0;
        position: relative;
        .p1 {
          display: flex;
          justify-content: space-between;
        }
        .up {
          position: absolute;
          right: -400px;
          bottom: 11px;
          font-size: 14px;
          width: 380px;
          height: 20px;
          line-height: 20px;
          padding-left: 44px;
          background: url("../../assets/assetcenter/public_create.png")
            no-repeat left;
          background-size: 16px 14px;
          vertical-align: middle;
        }
      }
      .rate {
        margin-bottom: 27px;
        position: relative;
      }
      .p2 {
        border-bottom: 1px solid #f0f1f9;
        margin: 50px 0 17px 0;
        display: flex;
        justify-content: space-between;
        padding-bottom: 8px;
        .s2 {
          font-weight: 500;
          white-space: 1;
        }
      }
      .filte {
        width: 224px;
      }
      .textarea {
        width: 460px;
        margin: 10px 0 22px 0;
        min-height: 51px;
        background: rgba(242, 244, 249, 1);
        border-radius: 4px;
        .area {
          padding: 18px 10px 0 10px;
          display: flex;
          .area-l {
            width: 72px;
            text-align: right;
            font-size: 14px;
            color: #333;
            font-weight: 500;
            padding-right: 10px;
          }
          .area-r {
            width: 380px;
            .p-text {
              display: inline-block;
              margin: 0 6px 12px 5px;
              height: 20px;
              background: rgba(252, 252, 252, 1);
              border-radius: 4px;
              border: 1px solid rgba(208, 208, 208, 1);
              span {
                margin: 0;
                padding-left: 5px;
                height: 20px;
                line-height: 19px;
              }
              .color-r {
                display: inline-block;
                color: #f08787;
                font-size: 12px;
                cursor: pointer;
                padding: 0 1px 0 5px;
              }
            }
          }
        }
      }
      .btn {
        margin: 30px 0;
        display: flex;
        justify-content: center;
        /deep/.ivu-btn {
          width: 360px;
          height: 50px;
          color: #fff;
          background: linear-gradient(
            90deg,
            rgba(129, 169, 250, 1) 0%,
            rgba(74, 112, 242, 1) 100%
          );
          border-radius: 25px;
        }
      }
    }
  }
}
</style>
